import { useTranslation } from 'react-i18next';
import { store } from 'src/state/dynamic-store';
import { RootState } from '@state/root-state.ts';
import { useSelector } from 'react-redux';
import { BusinessPartnersComponent } from '@sharedComponents/business-partner/BusinessPartnersComponent';
import { CdfBreadcrumbs } from '@commonComponents/navigation/CdfBreadcrumbs';

export function BusinessPartnersPage() {
  const { t } = useTranslation(['layouts']);
  const organizationId = useSelector((state: RootState) => state.appContext.selectedOrganizationId ?? '');

  return (
    <>
      <CdfBreadcrumbs items={[{ label: t('breadCrumbs.businessPartners.page') }]} />
      <BusinessPartnersComponent organizationId={organizationId} store={store}></BusinessPartnersComponent>
    </>
  );
}
